module.exports = require('./lib/font-subseter');
